export default __webpack_public_path__ + "static/media/ebusinesslogo.1509f68d.svg";